export class AsksPorSeasonKpi {
	public season: string;
	public ask: number;

	constructor(season: string, ask: number) {
		this.season = season;
		this.ask = ask;
	}
}
